export const isEmptyStr = (v: string | null | undefined) =>
  v === null || v === undefined || v === ''

/** 1차 뎁스 null/undefined 제외 객체 반환 */
export const convertNotNull = (obj?: { [key: string]: unknown }) => {
  if (!obj) return obj

  return Object.keys(obj)
    .filter(a => obj[a] !== null && obj[a] !== undefined)
    .reduce(
      (c, a) => {
        c[a] = obj[a]
        return c
      },
      {} as { [key: string]: unknown }
    )
}

/**
 * 문자를 숫자로 변환
 * @param numStr
 * @returns
 */
export const stringToNumber = (numStr: string | null | undefined) => {
  const number = Number(numStr?.replaceAll(',', ''))
  return isNaN(number) ? 0 : number
}

/** 파일명 추출 */
export const getFileName = (url = '') => {
  const pathnames = url.split('/')

  const filename = decodeURIComponent(pathnames.at(-1) ?? '')
  if (url.includes('/images/') && filename === 'original.png') {
    return decodeURIComponent(pathnames.at(-2) ?? '')
  }
  return filename
}

/** 확장자 가져오기 */
export const getExtension = (url: string = '') => {
  if (!url) return undefined

  const baseUrl = url.split('?')[0]
  const extension = baseUrl.split('.').at(-1)
  return extension === baseUrl ? undefined : extension
}

export const textTruncate = (text?: string | null, maxLength = 100) =>
  text && text.length > maxLength ? `${text.substring(0, maxLength - 3)}...` : text

export const convertToArray = (value?: string | string[], allowValues?: string[]) => {
  if (!value) return []

  if (typeof value === 'string') return !allowValues || allowValues.includes(value) ? [value] : []

  const result = [...value]
  return allowValues ? result.filter(_value => allowValues.includes(_value)) : result
}

export function isImgUrl(url: string) {
  return /\.(jpg|jpeg|png|webp|avif|gif)$/.test(url)
}

export const shuffleArray = <T>(array: T[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export function openWindowPopup({
  url,
  target,
  name,
  width = 500,
  height = 800,
  resizable,
  scrollbars,
  toolbar,
  menubar,
}: {
  url: string
  target?: string
  name?: string
  width?: number
  height?: number
  resizable?: boolean
  scrollbars?: boolean
  toolbar?: boolean
  menubar?: boolean
}) {
  const left = (screen.width - width) / 2
  const top = (screen.height - height) / 2
  return window.open(
    url,
    target,
    `name=${name},${resizable ? '' : 'resizable=false'},${scrollbars ? '' : 'scrollbars=false'},${toolbar ? '' : 'toolbar=false'},${menubar ? '' : 'menubar=false'},width=${width},height=${height},top=${top},left=${left}`
  )
}

export const parseJson = (jsonStr?: string | null, defaultValue = {}) => {
  try {
    if (!jsonStr) {
      return defaultValue
    }

    return JSON.parse(jsonStr) || defaultValue
  } catch (error) {
    console.error('JSON parsing failed:', error)

    return defaultValue
  }
}

/**
 * 문자열을 YYYY-MM-DD 형식으로 변환
 */
export const convertDateFormat = (value: string) => {
  return value.replace(/\D/g, '').replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
}

/** 문자열에서 숫자만 추출 */
export const getOnlyNumberStr = (str: string) => (str || '').replace(/[^0-9]/g, '')

/** 이름 마스킹 */
export const maskingName = (name: string | null) => {
  if (!name || name.length === 0) return ''

  if (name.length <= 3) {
    return name.charAt(0) + '*'.repeat(name.length - 1)
  }

  return name.charAt(0) + '*'.repeat(name.length - 2) + name.charAt(name.length - 1)
}

/** 전화번호 형식 */
export function replacePhoneNumber(numberString: string) {
  if (typeof numberString !== 'string') return ''
  const str = numberString.replace(/[^0-9]/g, '')
  if (str.indexOf('82') == 0) {
    return str.replace(/(^82)(2|\d{2})(\d+)?(\d{4})$/, '+$1-$2-$3-$4') // +82
  } else if (str.indexOf('1') == 0) {
    return str.replace(/(^1\d{3})(\d{4})$/, '$1-$2') // 1588, 1566, 1677, ...
  }
  return str.replace(/(^02|^0504|^0505|^0\d{2})(\d+)?(\d{4})$/, '$1-$2-$3') // 02/0504/0505/010/011/031
}

/** 문자열 최대길이 말줄임표 처리 */
export const setStringEllipsis = (str = '', maxLength: number) => {
  if (!str || Number.isNaN(maxLength)) return str

  if (str.length > maxLength) {
    return `${str.substring(0, maxLength - 3)}...`
  }
  return str
}
